import { memo, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import { Close as CloseIcon } from "components/icons";
import { handleAxiosError } from "app/services/app.error.handler";
import { useSelector } from "react-redux";
import MDBox from "components/MDBox";
import { validateWorkingHourObject } from "utils/clientValidationUtil";
import { addWorkingHourToBackend, updateWorkingHourToBackend } from "app/services/client.service";
import "./AddWorkingHoursDialog.css";

const obj = {
  id: null,
  location: "",
  clientId: null,
  hour: 0,
};

const AddWorkingHoursDialog = ({ open, setOpen, clientId, refreshActivitiesDataHandler, editObject }) => {
  const [message, setMessage] = useState("");
  const [messageOpen, setMessageOpen] = useState(false);
  const [severity, setSeverity] = useState("info"); // "error" or "warning" or "info" or "success"
  const [data, setData] = useState(obj);
  const locations = useSelector((state) => state.client.locations);

  useEffect(() => {
    setMessageOpen(false);
    setMessage("");
    if (!editObject) setData({...obj, clientId: clientId});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, editObject, clientId]);

  useEffect(() => {
    if (editObject) {
      setData({
        id: parseInt(editObject.id),
        location: editObject.location,
        hour: editObject.hour,
        clientId: clientId,
      });
    }
  }, [editObject, clientId]);

  const saveWorkingHourInBackend = async () => {
    if (validateWorkingHourObject(data) && !editObject) await addWorkingHourInvoker(data);
    else if (validateWorkingHourObject(data) && editObject) await updateWorkingHourInvoker(data);
    else {
      setErrorAction(
        "One or more required fields for Working Hours are missing or having invalid value"
      );
    }
  };

  const addWorkingHourInvoker = async (clientObject) => {
    await addWorkingHourToBackend(clientObject)
      .then((data) => {
        setSuccessAction("Working Hours added successfully");
        setTimeout(() => {
          setData(obj);
          setMessageOpen(false);
          setMessage("");
          setOpen(false);
          refreshActivitiesDataHandler();
        }, 1000);
      })
      .catch((error) => {
        handleAxiosError(error);
      });
  };

  const updateWorkingHourInvoker = async (data) => {
    const editObjectId = data.id;
    await updateWorkingHourToBackend(editObjectId, data)
      .then((data) => {
        setSuccessAction("Working Hours updated successfully");
        setTimeout(() => {
          setData(obj);
          setMessageOpen(false);
          setMessage("");
          setOpen(false);
          refreshActivitiesDataHandler();
        }, 1000);
      })
      .catch((error) => {
        handleAxiosError(error);
      });
  };

  const setErrorAction = (errorMessage) => {
    setMessage(errorMessage);
    setMessageOpen(true);
    setSeverity("error");
  };

  const setSuccessAction = (message) => {
    setMessage(message);
    setMessageOpen(true);
    setSeverity("success");
  };

  return (
    <Dialog open={open} fullWidth={true} maxWidth="sm">
      <DialogTitle>{editObject ? `Update Working Hours` : `Add New Working Hours`}</DialogTitle>
      <DialogContent>
        <MDBox my={2}>
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label" className="working-hours-form-label">
              Location
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={locations[1]}
              name="radio-buttons-group"
              value={data && data.location}
              onChange={(e) => setData({ ...data, location: e.target.value })}
            >
              {locations &&
                locations.map((option, index) => (
                  <FormControlLabel
                    value={option}
                    key={index}
                    control={<Radio />}
                    label={option}
                    style={{ fontWeight: 400 }}
                  />
                ))}
            </RadioGroup>
          </FormControl>
        </MDBox>
        {/* <MDBox my={2}>
          <TextField
            select
            id="client"
            label="Client"
            fullWidth
            variant="standard"
            value={data && data.clientId}
            onChange={(e) => setData({ ...data, clientId: e.target.value })}
            helperText="*Required"
            SelectProps={{
              native: true,
            }}
          >
            <option key={0}></option>
            {clients.map((client) => (
              <option key={client.id} value={client.id}>
                {client.name}
              </option>
            ))}
          </TextField>
        </MDBox> */}
        <MDBox my={2}>
          <TextField
            id="hour"
            label="Hours"
            fullWidth
            variant="outlined"
            value={data && data.hour}
            onChange={(e) => setData({ ...data, hour: e.target.value })}
            helperText="*Required"
          />
        </MDBox>
        <Collapse in={messageOpen}>
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setMessageOpen(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            severity={severity}
            sx={{ mb: 2 }}
          >
            {message}
          </Alert>
        </Collapse>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button onClick={saveWorkingHourInBackend} variant="contained">{editObject ? `Update` : `Add`}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(AddWorkingHoursDialog);
